import AddNewPersonModalView from "../events/guests/addNewPersonModal.html";


angular.module("correspondence")

    .controller("CorrespondenceEditCtrl", ['LoginService', '$scope', '$http', '$rootScope', '$state', '$stateParams', '$translate', 'Restangular', 'notificationService', '$filter', 'generateDocumentService', 'modalService', '$uibModal', 'logService', '$q', function (LoginService, $scope, $http, $rootScope, $state, $stateParams, $translate, Restangular, notificationService, $filter, generateDocumentService, modalService, $uibModal, logService, $q) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CORRESPONDENCE_WRITE");
        $rootScope.title = $filter('translate')('correspondence.title');
        $scope.allowFoldersFiles = LoginService.permissionExist("FILES_READ");
        $scope.allowTasks = LoginService.permissionExist("TASKS_READ");
        $scope.allowNotifications = LoginService.permissionExist("NOTIFICATIONS_READ");

        $scope.canManageEntityAcl = function (acl) {
            return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
        };
        $scope.aclUsers = [];
        $scope.aclGroups = [];
        $scope.aclOptionsLoaded = false;
        $scope.aclDialogState = { visible: false, savedVersion: 0 };

        let normalizeAclUser = function (user) {
            const name = user.name || user.username || ('User #' + user.id);
            const username = user.username || '';
            const words = name.trim().split(/\s+/);
            const initials = (words.length >= 2 ? words[0][0] + words[words.length - 1][0] : name.slice(0, 2)).toUpperCase();
            return { id: user.id, label: name, initials: initials, sub: (username && username !== name) ? username : (user.email || '') };
        };

        let normalizeAclGroup = function (group) {
            const name = group.name || ('Group #' + group.id);
            return { id: group.id, label: name, initials: name.slice(0, 2).toUpperCase(), sub: group.members_count ? (group.members_count + ' miembros') : '' };
        };

        $scope.loadAclOptions = function () {
            if ($scope.aclOptionsLoaded) return $q.when();
            return $q.all([
                Restangular.all('Users').getList(),
                Restangular.all('UsersGroups').getList()
            ]).then(function (results) {
                $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
                $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
                $scope.aclOptionsLoaded = true;
            });
        };

        $scope.openAclDialog = function () {
            $scope.loadAclOptions().then(function () {
                $scope.aclDialogState.visible = true;
            });
        };

        $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.correspondence.put().then(function (result) {
                    if (typeof result.id !== 'undefined') {
                        toastr.success($filter('translate')('correspondence.acl_save_success'));
                    }
                });
            }
        });

        $scope.correspondence = {
            to_name: null, from_name: null,
            from_person_id: null,
            to_person_id: null,
            status: 'pending',
            information_groups_values: []
        };

        $scope.changesNotSaved = false; //para que aparezca el texto de cambios no guardados
        $scope.tinymceDescriptionOptions = {
            resize: true,
            forced_root_block: 'p',
            //min_height: 60,
            //height: 60,
            schema: "html5",
            contextmenu: false,
            branding: false,
            formats: {
                bold: { inline: 'b' },
                underline: { inline: 'u' },
                italic: { inline: 'i' },
                alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
            },
            invalid_elements: 'strong,em',
            fontsize_formats: "8pt 10pt 12pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 25pt 28pt 30pt 36pt ",
            body_class: 'custom_tinymce_content',
            language: $translate.use() !== undefined ? $translate.use().toLowerCase() : null, //Hay que customizarlo dependiendo del idioma...
            plugins: 'textcolor paste link lists advlist',
            toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor | link | numlist bullist",
            menubar: false,
            paste_remove_styles: true, paste_remove_styles_if_webkit: true, paste_strip_class_attributes: true, paste_auto_cleanup_on_paste: true
        };

        //generamos lista de valores de persons informations groups

        let loadInformationGroups = function () { // Lo encapsulo en una función  para evitar problemas de asincronía

            $scope.correspondence.pigs = [];
            var options = { entity_type: "correspondence" };
            Restangular.all('InformationsGroups').getList(options).then(function (informationGroups) {
                $scope.informationGroups = informationGroups;
                $scope.informationGroups.forEach(function (pig) {
                    if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                });
                $scope.checkboxSimpleOptions = [
                    { option: null, label: $filter('translate')('informations.all'), checked: true },
                    { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                    { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                ];

                //Lo recorremos para pintarlos correctamente.
                angular.forEach($scope.correspondence.information_groups_values, function (pig) {
                    var infoFilter = $scope.informationGroups.filter(function (el) { return el.id == pig.information_group_id; });
                    if (infoFilter != null && infoFilter.length > 0) {
                        if (infoFilter[0].type == "checkboxSimple") {
                            $scope.correspondence.pigs[pig.information_group_id] = pig.value; //(pig.value == "true" || pig.value == true ? true : false);
                        } if (infoFilter[0].type == "datetime") {
                            $scope.correspondence.pigs[pig.information_group_id] = new Date(pig.value);
                        } if (infoFilter[0].type == "number") {
                            $scope.correspondence.pigs[pig.information_group_id] = parseInt(pig.value);
                        } else {
                            $scope.correspondence.pigs[pig.information_group_id] = pig.value;
                        }
                    }
                });
            });
        }

        // TODO: Revisar si se puede refactorizar esto 
        $scope.loadCorrespondence = function (id) {
            if (angular.isUndefined(id) || id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('correspondence.title'), url: "correspondence.list" },
                    { title: $filter('translate')('correspondence.title_add') },
                ];

                loadInformationGroups();

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('correspondence.title'), url: "correspondence.list" },
                    { title: $filter('translate')('correspondence.title_edit') },
                ];

                Restangular.one('Correspondences', id).get().then(function (result) {

                    $scope.correspondence = result;

                    $scope.correspondence.date = new Date($scope.correspondence.date);

                    if ($scope.correspondence.date_celebration != null) $scope.correspondence.date_celebration = new Date($scope.correspondence.date_celebration)
                    if ($scope.correspondence.from_person_id == null) {

                        if ($scope.correspondence.from_name != null) {
                            $scope.search.from_person = $scope.correspondence.from_name;
                        }

                    } else {
                        Restangular.one('Persons', $scope.correspondence.from_person_id).get().then(function (person) {

                            $scope.search.from_person = {
                                id: person.id,
                                term: person.name + ' ' + person.surname + (person.lastname != null ? ' ' + person.lastname : '')
                            };

                            if ($scope.correspondence.from_position_id != null) {
                                Restangular.one('Positions', $scope.correspondence.from_position_id).get().then(function (position) { // TODO

                                    $scope.search.from_position = {
                                        id: position.id,
                                        term: person.gender == "F" ? position.female_description : person.gender == "M" ? position.male_description : position.name
                                    };
                                    
                                });

                            }

                            $scope.personSelected($scope.search.from_person);

                        });
                    }

                    if ($scope.correspondence.from_position_id == null) {

                        if ($scope.correspondence.from_position_name != null) {

                            $scope.search.from_position = $scope.correspondence.from_position_name;

                        }
                    } else if ($scope.correspondence.from_person_id == null) {

                        Restangular.one('Positions', $scope.correspondence.from_position_id).get().then(function (results) { // TODO

                            $scope.search.from_position = {
                                id: results.id,
                                term: results.name
                            };

                        });

                    }
                    if ($scope.correspondence.to_person_id == null) {
                        if ($scope.correspondence.to_name != null) {
                            $scope.search.to_person = $scope.correspondence.to_name;
                        }
                    } else {
                        Restangular.one('Persons', $scope.correspondence.to_person_id).get().then(function (results) {
                            $scope.search.to_person = {
                                id: results.id,
                                term: results.name + ' ' + results.surname + (results.lastname != null ? ' ' + results.lastname : '')
                            };
                        });
                    }

                    loadInformationGroups();

                });
            }

        }

        $scope.loadCorrespondence($stateParams.id);

        let loadCombos = function () {
/*            Restangular.all('Persons/AllPersons').getList($scope.options).then(function (persons) {
                $scope.SelectPersons = persons;
                $scope.SelectPersons.unshift({
                    id: -1,
                    name: $filter('translate')('persons_gifts.another_persons')
                }); 
            });*/
            Restangular.all('CorrespondencesTypes').getList().then(function (results) {
                $scope.correspondencesTypes = results;
                /*$scope.correspondencesTypes.unshift({
                    id: null,
                    name: $filter('translate')('correspondence.allTypes')
                });*/
                if (results.length == 1 && (angular.isUndefined($stateParams.id) || $stateParams.id == "")){
                    $scope.correspondence.correspondence_type_id = results[0].id;
                }
            });
            $scope.status = [{ id: 'pending', name: $filter('translate')('correspondence.pending') }, { id: 'in_process', name: $filter('translate')('correspondence.in_process') }, { id: 'finalized', name: $filter('translate')('correspondence.finalized') }]
        }
        loadCombos();

        $scope.savedOptions = JSON.parse(localStorage.getItem("correspondences_options"));

        $scope.prepareNavigationBar = function () {

            $scope.savedOptions._pageSize = 1;
            Restangular.all('Correspondences/GetNextCorrespondenceId').post($scope.savedOptions).then(function (results) {
                var data = results.rows;
                let id = results.rows[0];
                $stateParams.id = id;

                $scope.savedOptions.row_index = $scope.savedOptions._page;
                localStorage.setItem("correspondences_options", JSON.stringify($scope.savedOptions));
                $state.go("correspondence.edit", { id: id }, { reload: true });
            });
        };
              
        $scope.navigatePrevious = function () {
            if ($scope.savedOptions._page > 1) $scope.savedOptions._page--;
            $scope.prepareNavigationBar();
            
        };
        $scope.navigateNext = function () {
            if ($scope.savedOptions._page < $scope.savedOptions._pages) $scope.savedOptions._page++;
            $scope.prepareNavigationBar();
            
        };

        $scope.saveCorrespondence = function () {

            if(typeof $scope.search.from_person === 'string') {
                $scope.correspondence.from_name = $scope.search.from_person;
            } else if (typeof $scope.search.from_person === 'object' && $scope.search.from_person != null) {

                $scope.correspondence.from_person_id = $scope.search.from_person.id;
                $scope.correspondence.from_name = $scope.search.from_person.term; // Rellenamos el nombre, de todos modos por la compatibilidad de los filtros

            }

            if(typeof $scope.search.from_position === 'string') {
                $scope.correspondence.from_position_name = $scope.search.from_position;
            } else if(typeof $scope.search.from_position === 'object' && $scope.search.from_position != null && $scope.search.from_position.id > 0) {
                $scope.correspondence.from_position_id = $scope.search.from_position.id;
                $scope.correspondence.from_position_name = $scope.search.from_position.term; // Rellenamos el nombre, de todos modos por la compatibilidad de los filtros
            }

            if(typeof $scope.search.to_person === 'string') {
                $scope.correspondence.to_name = $scope.search.to_person;
            } else if(typeof $scope.search.to_person === 'object' && $scope.search.to_person != null) {
                $scope.correspondence.to_person_id = $scope.search.to_person.id;
                $scope.correspondence.to_name = $scope.search.to_person.term; // Rellenamos el nombre, de todos modos por la compatibilidad de los filtros
            }
            angular.forEach($scope.informationGroups, function (pig) {
                var value = $scope.correspondence.pigs[pig.id];
                var pips = $filter("filter")($scope.correspondence.information_groups_values, { information_group_id: pig.id });
                if (pips != null && pips.length > 0) {
                    var pip = pips[0];
                    pip.value = value;
                } else {
                    var newPip = {
                        entity_type: "correspondence",
                        entity_type_id: (angular.isDefined($stateParams.id) && $stateParams.id != "" ? $scope.correspondence.id : null),
                        information_group_id: pig.id,
                        value: value
                    };
                    if (typeof (value) != "undefined") $scope.correspondence.information_groups_values.push(newPip);
                }
            });
            angular.forEach($scope.correspondence.information_groups_values, function (pig) {
                $scope.correspondence.pigs[pig.information_group_id] = pig.value;
            });

            if (angular.isDefined($scope.correspondence.id)) {
                $scope.correspondence.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('correspondence.edit_success'));
                        $state.go("correspondence.edit", { id: result.id });
                        $scope.changesNotSaved = false;
                    } else {
                        $scope.errorMessage = result.message;
                    }
                }, function (error) {
                    let title = $filter('translate')('general.error')
                    let message = error.data.ExceptionMessage
                    modalService.message({
                        title: title,
                        message: message,
                        onAccept: function () { }
                    });
                });
            } else {

                    Restangular.all('Correspondences').post($scope.correspondence).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('correspondence.save_success'));
                        $state.go("correspondence.edit", { id: result.id });
                        $scope.changesNotSaved = false;
                    } else {
                        $scope.errorMessage = result.message;
                    }
                    }, function (error) {
                        let title = $filter('translate')('general.error')
                        let message = error.data.ExceptionMessage
                        modalService.message({
                            title: title,
                            message: message,
                            onAccept: function () { }
                        });
                    });
            }
        }

        $scope.checkDelete = function (description) {
            modalService.confirm({
                title: $filter('translate')('correspondence.button_delete'),
                message: $filter('translate')('correspondence.delete_message') + "?",
                onAccept: function () {
                    Restangular.one('Correspondences', $stateParams.id).remove().then(function () {
                        toastr.success($filter('translate')('correspondence.deleted_success'));
                        $state.go("correspondence.list");
                    });
                }
            });
        };

        $scope.search = {
            "from_person": null,
            "from_position": null,
            "to_person": null,
            positions: [],
            persons: [],
            person_min_length: 3,
            position_min_length: 3
        };

        $scope.getPersonsSearch = function(val) {
            if(val == null) {
                val = '';
            }
            let ret = [];
            if($scope.search.from_position != null && $scope.search.from_position.id !== undefined) {
                angular.forEach($scope.search.persons, function (row) {
                    if(row.term.includes(val)) {
                        ret.push(row);
                    }
                });
            } else {
                ret = Restangular.all('search/person/' + val).getList().then(function (searchTerms) {

                    return searchTerms;

                });
            }
            return ret;
        };

        $scope.getPositionsSearch = function(val) {
            if(val == null) {
                val = '';
            }
            let ret = [];
            if($scope.search.from_person != null && $scope.search.from_person.id !== undefined) {
                angular.forEach($scope.search.positions, function (row) {
                    if(row.term.includes(val)) {
                        ret.push(row);
                    }
                });
            } else {
                ret = Restangular.all('search/position/' + val).getList().then(function (searchTerms) {
                    return searchTerms;
                });
            }
            return ret;
        };

        $scope.getPersonsToSearch = function (val) {
            return Restangular.all('search/person/' + val).getList().then(function (searchTerms) {
                return searchTerms;
            });
        };

        $scope.positionSelected = function($item, $model, $label) {
            $scope.search.person_min_length = 0;
            $scope.changesNotSaved = true;
            Restangular.all('PersonsPositions?position_id=' + $item.id).getList().then(function (results) {
                if(results.totalRows !== undefined && results.totalRows > 0) {
                    $scope.search.persons = [];
                    angular.forEach(results, function (row) {
                        $scope.search.persons.push({
                            id: row.FK_persons_positions_persons.id,
                            term: row.FK_persons_positions_persons.name + ' ' + row.FK_persons_positions_persons.surname + (row.FK_persons_positions_persons.lastname!=null?' ' + row.FK_persons_positions_persons.lastname:'')
                        });
                    });
                }
            });
        };
        $scope.personSelected = function ($item, $model, $label) {
            let today = new Date();
            $scope.search.position_min_length = 0;
            Restangular.one('Persons', $item.id).get().then(function (results) {
                if(results.FK_persons_positions_persons != undefined && results.FK_persons_positions_persons.length > 0) {
                    $scope.search.positions = [];
                    angular.forEach(results.FK_persons_positions_persons, function (row) {
                        if (row.to_date >= today || row.to_date == null) {
                            $scope.search.positions.push({
                                id: row.FK_persons_positions_positions.id, // Este es el position_id de cara a luego usarlo para buscar el correo
                                term: row.FK_persons_positions_positions.name
                            });
                        }
                    });

                }
            });
        };

        $scope.addNewPerson = function (person_type) {
            if ($rootScope.sizeLg) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewPersonModalView,
                    size: "x-lg",
                    controller: "AddNewPersonModalCtrl",
                    resolve: {
                        person_type: function () {
                            return person_type;
                        },
                    }
                }).closed.then(function (result) {
                    //no me devuelve parametros para poder preseleccionar a la persona...
                    Restangular.all('Persons/AllPersons').getList($scope.options).then(function (persons) {
                        $scope.SelectPersons = persons;
                        $scope.SelectPersons.unshift({
                            id: -1,
                            name: $filter('translate')('persons_gifts.another_persons')
                        });
                    });
                });

            } else {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewPersonModalView,
                    controller: "AddNewPersonModalCtrl",
                    resolve: {
                        person_type: function () {
                            return person_type;
                        },
                    }
                }).closed.then(function (result) {
                    Restangular.all('Persons/AllPersons').getList($scope.options).then(function (persons) {
                        $scope.SelectPersons = persons;
                        $scope.SelectPersons.unshift({
                            id: -1,
                            name: $filter('translate')('persons_gifts.another_persons')
                        });
                    });
                });
            }

        };

        $scope.documentAndEmail = function (email) {

            let params: any = {
                entity_type: "correspondence",
                entity_type_id: $stateParams.id,
                documents: { codes: ["CORRESPONDENCE_RESPONSE"] }
            };
            if (!email) {
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, correspondence_id: params.entity_type_id, outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                let url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            } else {

                let personId = ($scope.correspondence.from_person_id != -1 ? [$scope.correspondence.from_person_id] : null);
                params.persons_ids = personId;
                notificationService.notificationMail({
                    params: params,
                    onAccept: function (data) {
                        toastr.success($filter('translate')('notifications.sending_mail_success'));
                    }
                });

            }
        }

}]);

                